import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ReviewPolicyholderCoveragePlan = lazy(
  () => import('@pages/producer/ReviewPolicyholderCoveragePlan'),
);

export const ReviewPolicyholderCoveragePlanRoutes: RouteObject[] = [
  {
    path: '/review-policyholder-coverage-plan',
    element: (
      <React.Suspense>
        <ReviewPolicyholderCoveragePlan />
      </React.Suspense>
    ),
  },
];